<script>
    /**
     * 下拉选择
     */
    import NormalLabel from './NormalLabel';
    import NormalScrollbar from './NormalScrollbar';
    import { hideOptsMixin } from '../mixin';

    export default {
        mixins: [ hideOptsMixin ],
        name: 'fixed-drop-down',
        data () {
            return {
                optionList: this.options,
                droped: false,
                dropX: 0,
                dropY: 0,
                dropR: 0,
                hovering: false,
                minWidth: 1
            };
        },
        watch: {
            selected () {
                this.selectedItem = this.getSelected();
            },
            options (v) {
                this.optionList = v;
            }
        },
        computed: {
            isHideHasBtnWrap () {
                return this.optionList.filter(v => !v.isButton).length;
            },
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            },
            selectedItem: {
                get: function () {
                    return this.getSelected();
                },
                set: function () {
                }
            },
            dropStyle () {
                const style = {
                    top: this.dropY + 'px',
                    position: this.position
                };
                if (this.dropR) {
                    style.right = `${ this.dropR }px`;
                } else {
                    style.left = `${ this.dropX }px`;
                }
                return style;
            }
        },
        props: {
            canActive: {
                type: Boolean,
                default: false,
                required: false
            },
            options: {
                default () {
                    return [];
                },
                required: false
            },
            text: {
                default: '',
                required: false
            },
            selected: {
                default: null,
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            position: {
                default: 'absolute',
                required: false
            },
            dropTriangle: {
                type: Boolean,
                default: true,
                required: false
            },
            customDrop: {
                type: Boolean,
                default: false,
                required: false
            },
            optionHeight: {
                default: 300,
                required: false
            }
        },
        model: {
            prop: 'selected',
            event: 'select'
        },
        methods: {
            getSelected () {
                var i;
                for (i = 0; i < this.optionList.length; i++) {
                    if (this.optionList[i].value === this.selected) {
                        return {
                            text: this.optionList[i].showText ? this.optionList[i].showText : this.optionList[i].text,
                            value: this.optionList[i].value
                        };
                    }
                }
                return {
                    text: ' - ',
                    value: 0
                };
            },
            drop () {
                if (this.disabled === true) {
                    return false;
                }
                if (this.droped) {
                    this.fold();
                    return;
                }
                if (!this.$el) {
                    return;
                }
                this.$refs.optionList.style.opacity = 0;
                this.$refs.optionList.style.position = 'fixed';
                this.droped = true;
                var that = this;
                var rect = this.$el.getBoundingClientRect();
                this.dropX = Math.round(rect.left) + window.pageXOffset;
                this.dropY = Math.round(rect.top) + Math.round(rect.height + 8) + (window.pageYOffset || window.pageYOffset);
                this.minWidth = Math.round(rect.width) - 28 - 2;
                var limitWidth = document.documentElement.clientWidth;
                this.dropR = 0;
                if (limitWidth - (this.dropX + rect.width) < 80) {
                    this.dropX = 0;
                    this.dropR = limitWidth - Math.round(rect.right) - window.pageXOffset;
                }
                this.$nextTick(() => {
                    const optRect = this.$refs.optionList.getBoundingClientRect();
                    const optWidth = optRect.width;
                    if (this.dropR) {
                        this.dropR -= (optWidth / 2 - rect.width / 2);
                    } else {
                        this.dropX -= (optWidth / 2 - rect.width / 2);
                    }
                    var limitHeight = document.documentElement.clientHeight + window.pageYOffset;
                    if (limitHeight - (optRect.height + optRect.top) < 30) {
                        this.dropY = rect.top + window.pageYOffset - this.$refs.optionList.getBoundingClientRect().height - 7;
                    }
                    setTimeout(() => {
                        this.$refs.optionList.style.position = this.position;
                        this.$refs.optionList.style.opacity = 1;
                    }, 100);
                });
                this.outAreaMouseDown = function () {
                    if (that.hovering) {
                        return;
                    }
                    that.fold();
                };
                window.addEventListener('mousedown', this.outAreaMouseDown);
                this.$emit('expended', {target: this, status: true});
            },
            fold () {
                this.droped = false;
                this.$emit('expended', {target: this, status: false});
                window.removeEventListener('mousedown', this.outAreaMouseDown);
            },
            mousedown (item, e) {
                e.stopPropagation();
                if (item.disabled) {
                    return;
                }
                if (item.isButton) {
                    this.$emit('opt-click', item.value);
                    this.fold();
                    return false;
                }
                this.selectedItem.text = item.showText ? item.showText : item.text;
                this.selectedItem.value = item.value;
                this.$emit('select', item.value);
                this.fold();
                return false;
            },
            emptyFunc () {
            }
        },
        beforeDestroy () {
            document.body.removeChild(this.$refs.optionList);
        },
        mounted () {
            document.body.appendChild(this.$refs.optionList);
        },
        components: {
            NormalLabel, NormalScrollbar
        }
    };
</script>

<template>
    <div class="drop-frame fixed-drop-down"
         @click.prevent.stop="drop"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false"
         v-bind:class="[theme, {disabled: disabled,'drop-triangle':dropTriangle}]"
         v-bind:style="curStyle">
        <template v-if="optionList.length > 0">
            <slot v-if="customDrop"></slot>
            <div v-else class="selected" v-html="text"></div>
        </template>
        <transition name="fade">
            <div class="option-list"
                 @mousedown.stop="emptyFunc"
                 ref="optionList"
                 v-show="droped"
                 v-bind:style="dropStyle">
                <normal-scrollbar :height="optionHeight">
                    <div class="item-wrap" v-show="isHideHasBtnWrap">
                        <template v-for="item in optionList">
                            <div class="item"
                                 v-if="!item.isButton"
                                 @mousedown="mousedown(item, $event)"
                                 :key="item.value"
                                 :class="[{
                                active: (selectedItem.value == item.value && canActive),
                                disabled: item.disabled
                             } ]"
                                 :style="{'min-width': minWidth + 'px'}">
                                <!--<span v-html="item"></span>-->
                                <!--<span>{{item.text}}</span>-->
                                <normal-label :prefix-icon="item.icon"
                                              float="none"
                                >{{ item.text }}
                                </normal-label>
                            </div>
                        </template>
                    </div>
                    <div>
                        <template v-for="item in optionList">
                            <div class="item is-button"
                                 v-if="item.isButton"
                                 :key="item.value"
                                 @mousedown="mousedown(item, $event)"
                                 :style="{'min-width': minWidth + 'px'}">
                                <!--<span v-html="item"></span>-->
                                <!--<span>{{item.text}}</span>-->
                                <normal-label :prefix-icon="item.icon"
                                              float="none"
                                >{{ item.text }}
                                </normal-label>
                            </div>
                        </template>
                    </div>
                </normal-scrollbar>
            </div>
        </transition>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .drop-frame.no-border {
        /*display: inline-block;*/
        border-color: transparent;

        > .selected {
            padding: 0 23px 0 0px;
            font-size: 14px;
            font-family: cmsicon;
        }
    }

    .drop-frame {
        width: auto;
        min-width: 1px;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        margin: (@lineHeight - @widgetsHeight)/2 0;
        position: relative;
        cursor: pointer;

        > .selected {
            width: auto;
            min-width: 1px;
            height: @widgetsHeight;
            line-height: @widgetsHeight + 1;
            text-align: center;
            overflow: hidden;
            padding: 0 30px 0 15px;
            margin: 0;
            position: relative;
            font-size: 14px;
            cursor: pointer;
            position: relative;
            font-family: cmsicon;
        }

        &.drop-triangle :after {
            content: "\e69e";
            font-family: cmsicon;
            position: absolute;
            width: 14px;
            height: 36px;
            line-height: 36px;
            top: 1px;
            right: 10px;
            font-size: 12px;
            color: @otherNormalTitleClr;
        }
    }

    .option-list {
        opacity: 0;
        background-color: #fff;
        box-shadow: 0px 0px 4px 0px rgba(17, 6, 85, 0.16);
        width: auto;
        height: auto;
        min-width: 1px;
        min-height: 1px;
        overflow: auto;
        z-index: 20000;
        border-radius: @widgetsBorderRadius;

        .item-wrap {
            padding: 6px 0;
        }

        .item {
            width: auto;
            min-width: 1px;
            overflow: hidden;
            clear: both;
            margin: 0;
            height: @widgetsHeight;
            line-height: @widgetsHeight;
            padding: 0 14px;
            font-size: 14px;
            color: @otherTextClr;
            cursor: pointer;

            &.disabled {
                color: @otherBtnBorderNoteClr;
                cursor: not-allowed;

                .label {
                    cursor: not-allowed;
                }
            }

            &.active {
                color: @primaryBg;
            }

            .label {
                margin: 0;
            }

            &.is-button {
                &:first-child {
                    /*margin-top: 6px;*/
                    border-top: 1px solid @otherBorderClr;
                }
            }

        }

        .item:hover {
            background-color: @otherBtnHoverClr;
        }


    }
</style>
